import type { i18n } from 'i18next';

export function formatDuration(minutes: number | null, i18n: i18n): string | null {
    if (minutes === null || minutes === undefined) return null;

    const totalHours = Math.floor(minutes / 60);
    const totalMinutes = minutes % 60;

    const formattedHours = i18n.t(
        'shared.admin.workOrder.task.auditLog.taskTime.hours-count',
        { count: totalHours }
    );
    const formattedMinutes = i18n.t(
        'shared.admin.workOrder.task.auditLog.taskTime.minutes-count',
        { count: totalMinutes }
    );

    if (totalHours && totalMinutes) {
        return `${formattedHours} ${formattedMinutes}`;
    }

    if (totalMinutes) {
        return formattedMinutes;
    }

    return formattedHours;
}

export function formatFriendlyDuration(minutes: number | null, i18n: i18n, defaultReturnValue: string = '-'): string {
  if (typeof minutes !== 'number' || Number.isNaN(minutes)) {
    return defaultReturnValue;
  }

  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  let result = '';

  if (h > 0) {
    result = i18n.t(
    'shared.admin.workOrder.serviceRequest.hours-count-unit-symbol-format',
      { count: h }
    );
  }

  if (m > 0) {
    const formatedMinutes = i18n.t(
      'shared.admin.workOrder.serviceRequest.minutes-count-unit-symbol-format',
      { count: m }
    );

    result += (result ? ' ' : '') + formatedMinutes;
  }

  return result || defaultReturnValue;
}

export function convertMinutesToHoursAndMinutes(totalMinutes: number | null) {
  if (totalMinutes === null) {
    return { hours: null, minutes: null };
  }

  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  return { hours, minutes };
}

export const calculateTotalMinutes = (hours: number | null, minutes: number | null) => {
  const hoursValue = hours ?? 0;
  const minutesValue = minutes ?? 0;

  return hoursValue * 60 + minutesValue;
};
